import type * as msal from '@azure/msal-browser';
import { atom } from 'jotai';
import { IS_DEV_ENV } from '@/constants/env';

export const microsoftObjectAtom = atom<msal.PublicClientApplication | null>(
  null,
);

if (IS_DEV_ENV) {
  microsoftObjectAtom.debugLabel = 'microsoftObjectAtom';
}
